"use client";
import { useCurrentLocale } from "./LocaleProvider";
import { technicalInterface } from "@/content/company/technical-interface";
import styles from "./AustralianSteelBadge.module.css";

export function AustralianSteelBadge() {
  const locale = useCurrentLocale();
  const copy = technicalInterface[locale];
  return (
    <span className={styles.badge} lang={locale}>
      <span>{copy.steel}</span>
      <strong>{copy.madeInAustralia}</strong>
    </span>
  );
}
